(() => {

  const initTodayDrop = (root) => {

    if (
      root.dataset.goodlotTodayDropInitialized === 'true'
    ) {
      return;
    }

    root.dataset.goodlotTodayDropInitialized = 'true';


    /* MOBILE CAROUSEL */

    const track =
      root.querySelector('[data-goodlot-today-track]');

    const dots = [
      ...root.querySelectorAll('[data-goodlot-today-dot]')
    ];


    if (track && dots.length > 0) {

      const cards = [...track.children];


      const getCardScrollLeft = (card) => {

        const trackRect =
          track.getBoundingClientRect();

        const cardRect =
          card.getBoundingClientRect();

        const rawPosition =
          cardRect.left -
          trackRect.left +
          track.scrollLeft;

        const maxScroll =
          Math.max(
            0,
            track.scrollWidth -
            track.clientWidth
          );

        return Math.min(
          Math.max(0, rawPosition),
          maxScroll
        );

      };


      const setActive = (index) => {

        dots.forEach((dot, dotIndex) => {

          const active =
            dotIndex === index;

          dot.classList.toggle(
            'is-active',
            active
          );

          dot.setAttribute(
            'aria-selected',
            active ? 'true' : 'false'
          );

        });

      };


      dots.forEach((dot, index) => {

        dot.addEventListener('click', () => {

          const card = cards[index];

          if (!card) return;

          track.scrollTo({
            left: getCardScrollLeft(card),
            behavior: 'smooth'
          });

          setActive(index);

        });

      });


      let scrollFrame;


      track.addEventListener(
        'scroll',
        () => {

          if (window.innerWidth > 749) {
            return;
          }

          cancelAnimationFrame(scrollFrame);

          scrollFrame =
            requestAnimationFrame(() => {

              if (cards.length === 0) return;

              let closestIndex = 0;
              let closestDistance =
                Number.POSITIVE_INFINITY;


              cards.forEach((card, index) => {

                const distance =
                  Math.abs(
                    getCardScrollLeft(card) -
                    track.scrollLeft
                  );

                if (distance < closestDistance) {

                  closestDistance = distance;
                  closestIndex = index;

                }

              });


              setActive(
                Math.min(
                  closestIndex,
                  dots.length - 1
                )
              );

            });

        },
        { passive: true }
      );

    }


    /* DAILY 10AM PACIFIC COUNTDOWN */

    const countdown =
      root.querySelector(
        '[data-goodlot-next-drop-time]'
      );

    const countdownDay =
      root.querySelector(
        '[data-goodlot-next-drop-day]'
      );


    if (!countdown) {
      return;
    }


    const getPacificTime = () => {

      const formatter =
        new Intl.DateTimeFormat(
          'en-US',
          {
            timeZone: 'America/Los_Angeles',

            year: 'numeric',
            month: '2-digit',
            day: '2-digit',

            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',

            hourCycle: 'h23'
          }
        );


      return Object.fromEntries(
        formatter
          .formatToParts(new Date())
          .map((part) => [
            part.type,
            part.value
          ])
      );

    };


    const getDropData = () => {

      const parts =
        getPacificTime();

      const currentSeconds =
        Number(parts.hour) * 3600 +
        Number(parts.minute) * 60 +
        Number(parts.second);

      const dropSeconds =
        10 * 3600;


      if (currentSeconds < dropSeconds) {

        return {
          seconds:
            dropSeconds -
            currentSeconds,

          day: 'Today'
        };

      }


      return {
        seconds:
          24 * 3600 -
          currentSeconds +
          dropSeconds,

        day: 'Tomorrow'
      };

    };


    const updateCountdown = () => {

      const dropData =
        getDropData();

      const seconds =
        dropData.seconds;

      const hours =
        Math.floor(seconds / 3600);

      const minutes =
        Math.floor(
          (seconds % 3600) / 60
        );

      const remainingSeconds =
        seconds % 60;


      countdown.textContent =
        `${String(hours).padStart(2, '0')}:` +
        `${String(minutes).padStart(2, '0')}:` +
        `${String(remainingSeconds).padStart(2, '0')}`;


      if (countdownDay) {
        countdownDay.textContent =
          dropData.day;
      }

    };


    updateCountdown();


    root.goodlotCountdownInterval =
      window.setInterval(
        updateCountdown,
        1000
      );

  };


  const init = () => {

    document
      .querySelectorAll(
        '[data-goodlot-today-drop]'
      )
      .forEach(initTodayDrop);

  };


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );

  } else {

    init();

  }


  document.addEventListener(
    'shopify:section:load',
    (event) => {

      const root =
        event.target.querySelector?.(
          '[data-goodlot-today-drop]'
        );

      if (root) {
        initTodayDrop(root);
      }

    }
  );


  document.addEventListener(
    'shopify:section:unload',
    (event) => {

      const root =
        event.target.querySelector?.(
          '[data-goodlot-today-drop]'
        );

      if (
        root &&
        root.goodlotCountdownInterval
      ) {
        window.clearInterval(
          root.goodlotCountdownInterval
        );
      }

    }
  );

})();